module.exports = __webpack_public_path__ + "img/icon_03.6861206d.svg";